module.exports = __webpack_public_path__ + "img/tarjeta_sorteo_freidora_2024.784867c8.jpg";